import React, {useContext, useEffect} from "react";
import {useLocation} from "react-router-dom";

import carbonFilter from "../../../assets/images/solutions/CarbonFilter.png";
import CompanyCarousel from "../../../components/carousel";
import Footer from "../../../components/footer";
import Header from "../../../components/header";
import * as S from "./styles";
import GetInTouch from "../../../components/getInTouch";
import Questions from "../../../components/questions";
import Breadcrumbs from "../../../components/breadcrumbs";
import {GlobalContext} from "../../../context/global/globalContext";

function Carbon() {
  const {setBreadcrumbs} = useContext(GlobalContext);
  const location = useLocation();

  useEffect(() => {
    setBreadcrumbs([
      {label: "Home", path: "/"},
      {label: "Technologies", path: "/technologies"},
      {label: "Carbon", path: "/technologies/carbon"},
    ]);
  }, [location, setBreadcrumbs]);

  const questionsData = [
    {
      question: "What types of contaminants does activated carbon remove?",
      answer: "VOCs, H₂S, organic vapours, odours, and some acid gases.",
    },
    {
      question: "How often does the media need replacement?",
      answer:
        "It depends on concentration and flow rate, but we monitor and advise based on breakthrough indicators.",
    },
    {
      question: "Do you provide spent carbon disposal or regeneration?",
      answer: "Yes, through trusted partners we can help manage the full lifecycle.",
    },
  ];

  return (
    <>
      <Header />
      <S.Container>
        <Breadcrumbs />

        <S.MainHeading>Activated Carbon Filter</S.MainHeading>

        <S.TwoColumnSection>
          <S.Column>
            <S.Paragraph>
              Activated carbon is a highly efficient filtration medium used to purify air, gas, and
              liquid streams across a wide range of industries. Thanks to its enormous internal
              surface area and adsorption capacity, activated carbon captures pollutants, odors, and
              harmful substances with exceptional performance and reliability.
            </S.Paragraph>
            <S.Paragraph>
              With its ability to adsorb volatile organic compounds (VOCs), H₂S, ammonia, and other
              contaminants, activated carbon is an essential solution for emission control, liquid
              purification, and odor treatment in both temporary and permanent setups.
            </S.Paragraph>
          </S.Column>
          <S.ImageContainer>
            <img src={carbonFilter} alt="Carbon Scrubber Equipment" />
          </S.ImageContainer>
        </S.TwoColumnSection>

        <S.Section>
          <S.SectionTitle>How Activated Carbon Filters Work</S.SectionTitle>
          <S.Paragraph>
            Activated carbon is a processed form of charcoal, designed to maximize its internal
            surface area—up to 1000 m² per gram. This structure allows contaminants to become
            trapped in microscopic pores by a process called adsorption.
          </S.Paragraph>
          <S.Paragraph>
            As polluted air, gas, or liquid passes through an activated carbon bed, unwanted
            components such as VOCs, sulfur compounds, and colorants are adsorbed and held in place.
            Depending on the application, the carbon can be reactivated and reused, making the
            process sustainable and cost-efficient.
          </S.Paragraph>
          <S.Paragraph>
            Ecosystems Europe offers tailored activated carbon systems engineered for:
          </S.Paragraph>
          <S.List>
            <S.BulletItem color="black">
              Air purification in industrial exhausts and odor control units
            </S.BulletItem>
            <S.BulletItem color="black">
              Gas treatment, including H₂S and ammonia removal
            </S.BulletItem>
            <S.BulletItem color="black">
              Liquid filtration, including water, process fluids, and solvents
            </S.BulletItem>
          </S.List>
        </S.Section>

        <S.TwoColumnSection>
          <S.Column>
            <S.SectionTitle>Process Design</S.SectionTitle>
            <S.List>
              <S.BulletItem color="blue">Temperature Range: 0 to 60 °C</S.BulletItem>
              <S.BulletItem color="blue">Flow Rates: Designed for 500 to 60,000 Nm³/h</S.BulletItem>
              <S.BulletItem color="blue">Operating Pressure: -50 to +150 mbar</S.BulletItem>
              <S.BulletItem color="blue">Pressure Drop: 10–60 mbar</S.BulletItem>
              <S.BulletItem color="blue">Efficiency: up to 99,9% removal efficiency</S.BulletItem>
            </S.List>
          </S.Column>
          <S.Column>
            <S.SectionTitle>Materials</S.SectionTitle>
            <S.List>
              <S.BulletItem color="blue">Carbon steel</S.BulletItem>
              <S.BulletItem color="blue">Stainless steel (316L, 304L)</S.BulletItem>
              <S.BulletItem color="blue">FRP</S.BulletItem>
            </S.List>
          </S.Column>
        </S.TwoColumnSection>

        <S.QuestionsSpacing>
          <Questions items={questionsData} />
        </S.QuestionsSpacing>

        <S.ContainerTitles>
          <S.MiniTitle>Our Partners</S.MiniTitle>
          <S.Title>
            We partner with industry leaders to create clean alternatives to traditional industrial
            processes
          </S.Title>
        </S.ContainerTitles>

        <CompanyCarousel />
        <GetInTouch />
      </S.Container>
      <Footer />
    </>
  );
}

export default Carbon;
